module.exports = __webpack_public_path__ + "static/media/niivana-payment.d7a70ae5.png";